<template>

  <section>
    <el-row>
      <el-col :span="24">
        <el-alert v-if="!actionData.emails.sendMail"
          type="info"
          :title="'This ' + actionData.actionType + ' won\'t send e-mails'"
          description=""
          show-icon
          :closable="false">
            In the email settings, send email has been disabled. A manager level user can turn it on.&nbsp;
            <el-switch v-if="isTowerCo() && isManager()" v-model="actionData.emails.sendMail" />
          </el-alert>
        </el-col>

        <el-row>

          <el-col :span="24" align="center">

            <h4 :class="titleColour()">
              <small><i :class="actionData.workflow.icon"></i> {{actionData.workflow.name}}:</small>
               {{actionData.site.siteName}}
            </h4>

            <span v-if="actionData.organisation.colourCode && actionData.organisation.shortName">
              <org-badge class="pull-right" :organisation="actionData.organisation" />
            </span>
            <div v-else>
              <br />

              <span class="text-muted"><small>by: <b>{{actionData.organisation.name}}</b></small></span>
            </div>

          </el-col>
        </el-row>

        <el-row>
          <el-col v-if="isTablet || isDesktop" :span="24">
            <el-steps :active="activeStep-1" finish-status="success" align-center
            :direction="!(isTablet || isDesktop) ? 'vertical' : 'horizontal'">

              <el-step v-for="s in steps" :key="s.title" :description="s.title">
                <template #icon>
                  <i :class="s.icon" style="background: inherit;"></i>
                </template>
              </el-step>  <!-- :title="s.title" -->

            </el-steps>
          </el-col>

          <el-row>
              <el-col :span="24">

                <el-tabs type="border-card">

                  <el-tab-pane  v-for="partyNo in actionData.parties" :key="partyNo" :label="partyName(partyNo)" lazy>

                    <el-tabs v-model="selectedFileTab" @tab-click="onFileTabClick">
                      <el-tab-pane  v-for="(s, ind) in steps" :name="'fileStep' + Number(ind + 1)" :key="s.id" :disabled="reachedStep < Number(ind + 1)" lazy>
                        <template #label><i :class="s.icon">&nbsp;</i><span v-if="isDesktop">{{s.title}}</span></template>

                          <files-table
                            :title="s.title + (!partyOrg(partyNo) ? ': ' + partyName(partyNo) : '')"
                            :id="getFileTableRef(partyNo)"

                            :name="getFileTableRef(partyNo)"
                            :table-ref="'filestable' + partyNo"
                            :org-badge="partyOrg(partyNo)"

                            :site-id="actionData.site_id"
                            :type="actionData.actionType.toLowerCase()"
                            :type-id="actionData.id"
                            :step="ind + 1"
                            :partyNo="partyNo"
                            :step-data="step"
                            show-refresh
                            :show-search="false"
                            :disable-form="!isActive(actionData)"
                            size="small"
                            :upload-info="requestsInfo"
                            :upload-callback="afterUpload"
                            />

                    </el-tab-pane>
                    </el-tabs>

                  </el-tab-pane>
                </el-tabs>
            </el-col>

        </el-row>

        <br />

        </el-row>

        <el-collapse v-model="show" accordion>
          <el-collapse-item name="map">
            <template #title>
                <span class="text-info">Map&nbsp;<i class="header-icon fa fa-map-marker"></i></span>
              </template>
              <site-map :row-data="actionData" />
          </el-collapse-item>


          <el-collapse-item name="workflow">
            <template #title>
                <span class="text-info">Workflow&nbsp;<i class="header-icon fa fa-ellipsis-h"></i></span>
              </template>

              <el-row>
                <el-col :offset="1" :span="21">
                <center><h4 v-if="steps[activeStep-1]"><i :class="steps[activeStep-1].icon"></i> {{steps[activeStep-1].title}}</h4> <small class="text-muted">| Step {{activeStep}} of {{steps.length}}</small></center>
                <br />

             <el-row :gutter="16">
               <el-col :span="22" :offset="2">
                 <el-form :model="state">
                   <component :is="comp" @updated="stepUpdated" :row-data="rowData" :row-index="rowIndex" :step-data="step" :read-only="readOnly" />
                </el-form>
                </el-col>
               </el-row>

                 <el-row v-if="isTowerCo()">

                   <el-col v-if="activeStep > 1" :span="4" align="center">
                      <el-button type="text" @click="prevStep()">&lt;&nbsp;Previous Step</el-button>
                   </el-col>

                   <el-col :span="8" :push="activeStep > 1 ? 4 : 8" align="center">
                     <el-alert show-icon :type="step.completed ? 'success' : 'warning'" center :closable="false">
                       <check-box v-if="isTowerCo() && isManager()" v-model="step.completed" no-form @change="completeStep" :disabled="step.approved && step.completed">Complete Step</check-box>
                       &nbsp;<span v-if="step.completed">on <b>{{formatDateTime(step.completed_at)}}</b> by <b>{{step.completed_by}}</b></span>
                       <span v-else>Step Pending Approval</span>
                     </el-alert>
                   </el-col>

                   <el-col :span="(activeStep > 1 ? 12 : 16)"  :pull="1" align="right">
                     <el-button v-if="activeStep <= steps.length" type="info" @click="nextStep()" :disabled="!validateStep(activeStep) || savingStep" :loading="savingStep" :aria-disabled="!validateStep(activeStep) || savingStep">Finish Step <b>{{activeStep}}</b> / {{steps.length}}</el-button>
                     <el-button v-if="isTowerCo() && activeStep === steps.length && step.approved" type="success" @click="completeWorkflow()" :disabled="!validateStep(activeStep)">Complete {{actionData.actionType}}</el-button>
                   </el-col>
                 </el-row>

            </el-col>
          </el-row>
        </el-collapse-item>

  </el-collapse>
  </el-row>

  <el-row>
    <el-col :span="4">
      <small class="text-muted">{{actionData.actionType}} # <b>{{actionData.id}}-{{step.partyNo}}-{{step.stepNo}}/{{step.id}}</b></small>
    </el-col>

    <el-col :span="20" align="right">

      <div>
        <popup heading="Configure Emails"
          :button-text="configNeeded ? 'Emails Setup' :  'Emails Update'"
          :button-style="configNeeded ? 'danger' : 'text'"
          :show-save="false"
          :center-button="true"
          button-icon="fa fa-envelope">

        <email-setup :row-data="actionData" :rtx-info="rtxInfo" />

      </popup>
    </div>
  </el-col>

  </el-row>

</section>
</template>


<script>


import RequestMixins from '@/mixins/RequestMixins'

import EmailSetup from '@/components/requests/EmailSetup'
import FilesTable from '@/components/tables/FilesTable'

import step1 from '@/components/requests/workflow/step1'
import step2 from '@/components/requests/workflow/step2'
import step3 from '@/components/requests/workflow/step3'
import step4 from '@/components/requests/workflow/step4'
import step5 from '@/components/requests/workflow/step5'

import SiteMap from '@/components/requests/SiteMap'


export default {
  mixins: [RequestMixins],

  components: {
    EmailSetup,
    FilesTable,
    step1,
    step2,
    step3,
    step4,
    step5,
    SiteMap
  },

  props: {

    rowData: {
      type: Object,
      default: null
    },

    rowIndex: {
      type: Number,
      default: null
    },

    isNew: {
      type: Boolean,
      default: false
    },

    closeDialog: {
      type: Function,
      default: null
    }
  },

  methods: {

    getFileTableRef (pNo) {
      return 'filestable' + this.activeStep + '-' + pNo
    },



    validateStep (stepNo) {

      let moveOn = false

      switch (stepNo) {
        case 1:
          moveOn = this.step.completed
          break
        case 2:
          moveOn = this.step.completed // && this.step.approved
          break
        case 3:
          moveOn = this.step.completed
          break
        case 4:
          moveOn = this.step.completed
          break
        case 5:
          moveOn = this.step.completed
          break
        default:
          moveOn = false
          break
      }

      return moveOn
    },



    nextStep () {

      if (!this.validateStep(this.activeStep)) {
        return
      }

      if (!this.actionData.site_id || !this.isActive(this.actionData)) {
        return
      }

      var nextActiveStep = this.activeStep + 1

      if (nextActiveStep > this.steps.length) {
        return
      }

      var snapshot = {
        currentStep: this.actionData.currentStep,
        status: this.actionData.status,
        activeStep: this.activeStep,
        reachedStep: this.reachedStep,
        step: this.step,
        comp: this.comp
      }

      this.actionData.currentStep = Math.max(nextActiveStep, this.actionData.currentStep)
      this.actionData.status = this.steps[nextActiveStep - 1].title
      this.activeStep = nextActiveStep
      this.reachedStep = Math.max(nextActiveStep, this.reachedStep)
      this.changeStep(nextActiveStep)

      this.savingStep = true

      var self = this
      this.saveRequest(this.actionData, function (response) {
        self.savingStep = false
      }, null, function (err) {
        self.savingStep = false
        self.actionData.currentStep = snapshot.currentStep
        self.actionData.status = snapshot.status
        self.activeStep = snapshot.activeStep
        self.reachedStep = snapshot.reachedStep
        self.step = snapshot.step
        self.comp = snapshot.comp
        self.changeStep(snapshot.activeStep)
        self.$notify({
          type: 'error',
          title: 'Couldn\'t advance step',
          message: 'We couldn\'t save the step change. Please check your connection and try again.',
          duration: 5500
        })
        console.error('nextStep save failed, rolled back to step', snapshot.activeStep, err)
      }, true)
    },



    prevStep () {
      this.activeStep -= 1

      if (this.activeStep <= 0) {
        this.activeStep = 1
      }

      this.changeStep(this.activeStep)
    },


    stepUpdated (data) {
      this.step = data
      this.saveStepData(this.step)
    },



    changeStep (stepNo) {

      if (this.canWriteStep() && !this.isViewOnly() && this.step) {
        this.saveStep(this.step)
      }

      this.step = this.stepData(stepNo - 1)
      if (stepNo > this.actionData.currentStep) { this.actionData.currentStep = stepNo }
      if (stepNo > this.reachedStep) { this.reachedStep = stepNo }
      this.selectedFileTab = 'fileStep' + stepNo

      switch (stepNo) {
        case 1:
          this.comp = step1
          break
        case 2:
          this.comp = step2
          break
        case 3:
          this.comp = step3
          break
        case 4:
          this.comp = step4
          break
        case 5:
          this.comp = step5
          break
        default:
          this.comp = step1
      }

    },


    onFileTabClick (pane) {
      const n = Number(String(pane.name || pane.paneName || '').replace('fileStep', ''))

      if (!n || Number.isNaN(n) || n === this.activeStep) {
        return
      }

      if (n > this.reachedStep) {
        return
      }

      this.activeStep = n
      this.changeStep(n)
    },



    completeStep () {
      //    this.step2p1 = this.findWorkflowStep(2, 1, this.steps)

      if (this.step.completed) {
        this.step.completed_at = this.formatDateTimeSql(new Date())
        this.step.completed_by = this.userName()
      } else {
        this.step.completed_at = null
        this.step.completed_by = null
      }

      this.$emit('updated', this.step)
    },


    saved (response) {
      if (response && !response.warning) {
        if (this.actionData && !this.actionData.id) {
        }
      }
    },



    completeWorkflow () {

      if (this.isNew) {

        if (this.isActive(this.actionData)) {
          this.saveRequest(this.actionData, this.saveAndClose)
        }

      } else {

        if (this.isTowerCo() && this.isManager() && this.step.approved) {

          this.step.completed = true
          this.step.completed_at = this.formatDateTimeSql(new Date())
          this.step.completed_by = this.userName()
          this.actionData.status = this.step.approvedStatus === 'Approved' ? 'Closed' : this.step.approvedStatus
          this.actionData.approved_at = this.step.completed_at
          this.actionData.approved_by = this.userName()

          this.saveRequest(this.actionData)
          this.refreshStats(this.org().id, true)
        }

      }

    },



    saveAndClose (response) {

      if (this.closeDialog) {
        this.closeDialog()
      }

    },



    stepData (current = 1) {

      if (this.rowData.steps && this.rowData.steps.length > 0) {

        if (this.activeStep) {
          current = this.activeStep
        }

        var partyNo = this.isTowerCo() ? 1 : 2

        for (var i = 0; i < this.rowData.steps.length; i++) {
          var s = this.rowData.steps[i]

          if (s.stepNo === current && s.partyNo === partyNo) {
            return s
          }

        }
      }

      return null
    },



    saveStepData (stepData, partyNo = 1) {
      if (this.steps && this.steps.length > 0) {

        var stepNo = stepData.stepNo

        var orgId = this.isTowerCo()
          ? Number(this.xolasClient().id)
          : Number(this.org().id)

        if (!this.isTowerCo()) {
          partyNo = 2
        }

        for (var i = 0; i < this.steps.length; i++) {
          var s = this.steps[i]

          if (s.stepNo === stepNo && s.partyNo === partyNo && s.organisation_id === orgId) {
            this.steps[i] = stepData
          }

        }
      }

      return null
    },



    partyName (partyNo) {
      if (!partyNo || !this.actionData.steps || !this.actionData.steps[this.activeStep]) {
        return 'Not Found'
      } else {

        for (let i = 0; i < this.actionData.steps.length; i++) {
          let wf = this.actionData.steps[i]
          if (wf.stepNo === this.activeStep && wf.partyNo === partyNo) {
            return (wf.org.shortName ? wf.org.shortName : wf.org.name)
          }

        } // for

        return 'Not Found'
      }
    },



    partyOrg (partyNo) {
      if (!partyNo || !this.actionData.steps || !this.actionData.steps[this.activeStep]) {
        return null
      } else {

        for (let i = 0; i < this.actionData.steps.length; i++) {
          let wf = this.actionData.steps[i]
          if (wf.stepNo === this.activeStep && wf.partyNo === partyNo) {
            return wf.org
          }

        } // for

        return null
      }
    },



    titleColour () {
      switch (this.requestType) {
        case 'rta': return 'text-warning'
        case 'rts': return 'text-success'
        case 'rtu': return 'text-primary'
        case 'rtb': return 'text-info'
        case 'rtd': return 'text-danger'
        default: return 'text-info'
      }
    }

  },   // methods



  computed: {

    configNeeded: function () {
      var config = true
      var i = 0

      if (this.isTelco()) {

        for (i = 0; i < this.emails.telco.length; i++) {
          if (this.emails.telco[i]) {
            config = false
            break
          }
        }

      } else {

        for (i = 0; i < this.emails.tower.length; i++) {
          if (this.emails.tower[i]) {
            config = false
            break
          }
        }
      }  // if..else

      return config
    },

requestsInfo: function () {
      return this.info(this.rowData, this.step, this.activeStep)
    }

  },



  watch: {

    actionData: function (value) {
      this.actionData = value
    },

    state: function (value) {
      this.state = value
    }

  },



  data () {

    return {
      show: 'workflow',
      actionData: this.rowData,
      state: this.rowData.state,
      comp: step1,
      step: this.stepData(),
      selectedFileTab: 'fileStep' + ((this.rowData && this.rowData.currentStep) ? this.rowData.currentStep : 1),
      readOnly: (this.rowData.status === 'Closed' || this.rowData.status === 'Rejected'),
      requestType: (this.rowData.actionType ? this.rowData.actionType.toLowerCase() : 'rtx'),
      activeStep: (this.rowData && this.rowData.currentStep) ? this.rowData.currentStep : 1,
      reachedStep: (this.rowData && this.rowData.currentStep) ? this.rowData.currentStep : 1,
      fileStep: (this.rowData && this.rowData.currentStep) ? this.rowData.currentStep : 1,
      savingStep: false,
      emails: this.rowData.emails,
      rtxInfo: this.info(this.rowData, this.stepData(), 1),
      steps: null
    }

  },



  created () {
    this.steps = this.workflow(this.step.partyNo, this.actionData.steps)

    if (this.actionData.currentStep > 1) {
      this.changeStep(this.actionData.currentStep)
    }

    if (this.isNumber(this.step.approved)) {
      this.step.approved = Boolean(this.step.approved)
    }

    if (this.isNumber(this.step.completed)) {
      this.step.completed = Boolean(this.step.completed)
    }

  }

}

</script>

<style scoped>
  .el-select {display: inline-block; width: 100%;}
</style>
